import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type CarePlansTableHeaderProps = {
  className?: string;
  title: string;
};

export const CarePlansTableHeader: React.FC<CarePlansTableHeaderProps> = ({ className, title }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Typography className={cx(styles.container, className)} variant="body">
      {t(title)}
    </Typography>
  );
};

const makeStyles = () => ({
  container: css({
    fontWeight: "bold",
  }),
});
